/* eslint-disable react-hooks/exhaustive-deps */
import { Badge } from 'react-bootstrap';
import useDataTable from '../../../hooks/useDataTable';

export default function ShowTable({ data }) {
    const columns = [
        {
            name: 'Item Name',
            selector: (row) => row.drug_name,
            sortable: true,
            wrap: true,
            grow: 3,
        },
        {
            name: 'Returned Qty',
            selector: (row) => row.return_qty,
            center: true,
            sortable: true,
        },
        {
            name: 'Returned Apv Qty',
            selector: (row) => row.return_approved_qty,
            center: true,
            sortable: true,
        },
        {
            name: 'Received Qty',
            selector: (row) => row.receive_approved_qty,
            center: true,
            sortable: true,
        },
        {
            name: 'Status',
            sortable: true,
            center: true,
            cell: (row) =>
                row.status === 'approved' ? (
                    <Badge className="badgeActive" bg="success">
                        Approved
                    </Badge>
                ) : row.status === 'received' ? (
                    <Badge className="badgeActive" bg="success">
                        Received
                    </Badge>
                ) : (
                    <Badge className="badgeInactive" bg="success">
                        Pending
                    </Badge>
                ),
        },
    ];

    const search_column = {
        // drug_name: 'Name',
    };
    return useDataTable({ columns, data, search_column });
}
